var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},_vm._l((_vm.courses),function(course){return _c('div',{key:course.title,staticClass:"row"},[_c('course-card',_vm._b({},'course-card',course,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }